import { NavigationGroup } from '../sidebar-admin-default/sidebar.model'

export const vendorNavigationGroups: NavigationGroup[] = [
    {
        label: 'Main',
        icon: 'lucideLayoutDashboard',
        expanded: true,
        items: [
            {
                label: 'Overview',
                icon: 'lucideLayoutDashboard',
                routerLink: '/vendor/overview',
            },
            {
                label: 'Benefits',
                icon: 'lucideTag',
                routerLink: '/vendor/benefits',
            },
            {
                label: 'Applications',
                icon: 'lucideClipboardList',
                routerLink: '/vendor/applications',
            },
            {
                label: 'Vouchers',
                icon: 'lucideTicket',
                routerLink: '/vendor/vouchers',
            },
        ],
    },
    {
        label: 'Management',
        icon: 'lucideSettings',
        expanded: true,
        items: [
            {
                label: 'Targeting & Availability',
                icon: 'lucideCrosshair',
                routerLink: '/vendor/targeting',
            },
            {
                label: 'Team Members',
                icon: 'lucideUsers',
                routerLink: '/vendor/team',
            },
        ],
    },
    {
        label: 'Business',
        icon: 'lucideBarChart3',
        expanded: true,
        items: [
            {
                label: 'Analytics',
                icon: 'lucideBarChart3',
                routerLink: '/vendor/analytics',
            },
            {
                label: 'Company Profile',
                icon: 'lucideBuilding2',
                routerLink: '/vendor/company-profile',
            },
            {
                label: 'Settings',
                icon: 'lucideSettings',
                routerLink: '/vendor/settings',
            },
        ],
    },
]
